var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4745 11.1217V7.85337C18.4745 3.76796 16.8403 2.13379 12.7549 2.13379H7.8524C3.76698 2.13379 2.13281 3.76796 2.13281 7.85337V12.7559C2.13281 16.8413 3.76698 18.4755 7.8524 18.4755H11.1207",
    stroke: "#755421",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48828 12.3396L8.43294 9.81479C8.71075 9.45528 9.22552 9.38992 9.58503 9.66773L11.0803 10.8443C11.4398 11.1221 11.9546 11.0568 12.2324 10.7054L14.1199 8.27051",
    stroke: "#755421",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4186 13.4258L16.6474 13.8915C16.7618 14.1203 17.0478 14.3327 17.301 14.3818L17.6115 14.4308C18.543 14.586 18.7636 15.2724 18.0936 15.9506L17.8076 16.2365C17.6197 16.4326 17.5135 16.8085 17.5707 17.07L17.6115 17.2416C17.8648 18.3691 17.2684 18.8022 16.2879 18.2139L16.0754 18.0913C15.8221 17.9442 15.4136 17.9442 15.1603 18.0913L14.9478 18.2139C13.9592 18.8103 13.3627 18.3691 13.6242 17.2416L13.665 17.07C13.7222 16.8085 13.616 16.4326 13.4281 16.2365L13.1421 15.9506C12.4721 15.2724 12.6927 14.586 13.6242 14.4308L13.9347 14.3818C14.1798 14.3409 14.4739 14.1203 14.5883 13.8915L14.8171 13.4258C15.2583 12.5352 15.9774 12.5352 16.4186 13.4258Z",
    stroke: "#755421",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceChart);
export default __webpack_public_path__ + "static/media/experience-chart.82a3c33582da58c804dbd965cc051091.svg";
export { ForwardRef as ReactComponent };